export default function Description({ description }) {
    return (
        <div
            className="tab-panel active"
            id="description">
            <div className="conference-information wysiwyg-content">
                <p dangerouslySetInnerHTML={{__html: description}} />
            </div>
        </div>
    )
}
